// extracted by mini-css-extract-plugin
module.exports = {"ourValues":"OurValues_ourValues__Y32p_","valuesWrapper":"OurValues_valuesWrapper__MK7fV","value":"OurValues_value__MGecP"};